export default __webpack_public_path__ + "static/media/1315.809fd2bc.png";